import { SPECIALTY_COVID_19_VACCINATIONS } from '../../bookings/constants';

export const specialtyIsCovax = (specialist?: string) =>
  specialist?.toLowerCase() === SPECIALTY_COVID_19_VACCINATIONS.toLowerCase();
